// extracted by mini-css-extract-plugin
export var cardLayout = "_a0-1";
export var paginationContainer = "_a0-0";